import { Avatar, Box, Chip, Tooltip, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import ReactComponent from '../ReactComponent';

const TooltipMagistradoContent = ({ exibirFoto, foto, nomeMagistrado }) => {
    if (exibirFoto && foto?.imgBase64) {
        const srcFoto = `data:image/${foto.imgContentType || 'jpeg'};base64,${foto.imgBase64}`;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 1 }}>
                <Avatar
                    sx={{ width: 120, height: 120, mb: 1, border: '1px solid #ccc' }}
                    src={srcFoto}
                />
                <Typography>{nomeMagistrado}</Typography>
            </Box>
        );
    }

    return <Typography variant="body2">{nomeMagistrado}</Typography>;
};

TooltipMagistradoContent.propTypes = {
    foto: PropTypes.shape({
        imgBase64: PropTypes.string,
        imgContentType: PropTypes.string
    }),
    exibirFoto: PropTypes.bool,
    nomeMagistrado: PropTypes.string
};

class RelatorChip extends ReactComponent {
    state = {
        foto: null
    };

    componentDidMount() {
        this.iniciarCarregamentoFoto();
    }

    async iniciarCarregamentoFoto() {
        const { relator, composicao, exibirFoto } = this.props;

        if (!exibirFoto || !this.fotoMagistradoStore || !relator?.sigla || !composicao) {
            return;
        }

        const magistradoComposicao = composicao.find((comp) => comp.magistrado?.sigla === relator.sigla);

        if (!magistradoComposicao) {
            return;
        }

        try {
            const foto = await this.fotoMagistradoStore.consultarMagistradoComposicao(magistradoComposicao);
            this.setState({ foto });
        } catch (error) {
            console.error(`Erro ao carregar foto do magistrado ${relator.sigla}:`, error);
        }
    }

    render() {
        const { relator, composicao, exibirFoto, size, ...outrasPropsChip } = this.props;
        const { foto } = this.state;
        const magistradoComposicao = composicao?.find((comp) => comp.magistrado?.sigla === relator.sigla);

        const tooltip = (
            <TooltipMagistradoContent
                foto={foto}
                exibirFoto={exibirFoto}
                nomeMagistrado={magistradoComposicao?.magistrado?.nome || relator.nome}
            />
        );

        return (
            <Tooltip
                title={tooltip}
                disableInteractive
            >
                <Chip
                    label={`✍️ ${relator?.sigla || '?'}`}
                    size={size}
                    {...outrasPropsChip}
                />
            </Tooltip>
        );
    }
}

RelatorChip.defaultProps = {
    exibirFoto: true,
    composicao: [],
    size: 'small'
};

RelatorChip.propTypes = {
    relator: PropTypes.shape({
        sigla: PropTypes.string,
        nome: PropTypes.string
    }).isRequired,

    composicao: PropTypes.arrayOf(
        PropTypes.shape({
            magistrado: PropTypes.shape({
                sigla: PropTypes.string,
                nome: PropTypes.string,
                cpf: PropTypes.string
            }),
            imagem: PropTypes.shape({
                url: PropTypes.string
            })
        })
    ),

    exibirFoto: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium'])
};

export default inject('stores')(observer(RelatorChip));
